// extracted by mini-css-extract-plugin
export var chip = "chip-module--chip--YwjC+";